import { BBModel } from 'types/story';

/**
 * Walk components depth-first and call a callback on each
 *
 * @function componentWalk
 * @param {!Array}   components  - Array of components
 * @param {callback} cb          - callback to run on each components
 * @param {string}   [path]      - dot-notated path to component in components param
 * @example
 *      const arr: BBSymbolInstance[] = [];
 *
 *      componentWalk<BBSymbolInstance>(arr, function step({ component }) {
 *          componentWalk<BBSymbolInstance>(component.children, step);
 *      });
 *
 * @return void
 */

export const componentWalk = <T = BBModel>(
	components: T[] | BBModel['children'],
	cb: (props: { component: T; index: number; path: string }) => void,
	path: string = ''
) => {
	if (!Array.isArray(components)) {
		return;
	}
	components.forEach(
		(component, index) =>
			component &&
			cb({
				component,
				index,
				path: path === '' ? `${index}` : `${path}.children.${index}`,
			})
	);
};
